import fetch from '../utils/fetch';
import { companyURL } from '../endpoints';

function CompanyService() {
    const promiseCache = {};

    const cache = ( name, fn ) => {
        return async () => {
            if ( !promiseCache[ name ] ) {
                promiseCache[ name ] = fn();
            }
            return promiseCache[ name ];
        };
    };

    const listCompanies = cache( 'listCompanies', async () => {
        const res = await fetch( `${ companyURL }/companies`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
        } );

        const data = await res.json();

        if ( data?.errors ) {
            throw new Error( data.errors.join( '\n' ) );
        }
        return data.companyList.sort(
            ( a, b ) => a.name.localeCompare( b.name, undefined, { 'sensitivity': 'base' } )
        );
    } );

    const getCompany = async ( companyId ) => {
        const res = await fetch( `${ companyURL }/company/${ companyId }`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
        } );

        const data = await res.json();
        if ( data?.errors ) {
            throw new Error( data.errors.join( '\n' ) );
        }

        return data;
    };

    return {
        listCompanies,
        getCompany
    };
}

export default new CompanyService();
